import {useNavigate, useParams} from 'react-router-dom'
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import React, {useEffect, useRef, useState} from "react"
import {getFieldErrorParams, getInputValue} from "../../../utils"
import AdminContainer from "../../../components/admin/AdminContainer"
import {Grid} from "@mui/material"
import {useGlobalContext} from "../../../contexts/global_context"
import {BACKEND_URL, BRAND_NAME} from "../../../data/config"
import MenuItem from "@mui/material/MenuItem";
import {Helmet} from "react-helmet";

const TemplateCreateUpdateAdminPage = () => {
  const navigate = useNavigate()
  let {uid} = useParams()
  let form = useRef()
  let {sendAjax} = useGlobalContext()
  let [fieldErrors, setFieldErrors] = useState({})

  useEffect(() => {
    if (uid) {
      sendAjax({
        url: `${BACKEND_URL}/api/v1/notifications/admin/templates/${uid}/`,
        method: 'get',
        data: {},
      }).then((r) => {
        if (r.data.status_code === 200) {
          let template = r.data.data
          setFormValues({
            subject: template.subject,
            body: template.body,
            template_type: template.template_type,
            template_type_display: template.template_type_display,
            status: template.status,
            status_display: template.status_display,
          })
        }
      })
    }
  }, [])

  let [formValues, setFormValues] = useState({
    subject: '',
    body: '',
    template_type: '',
    template_type_display: '',
    status: '',
    status_display: '',
  })

  const afterSubmit = (r) => {
    if (r.data.status_code === 200) {
      navigate("/admin/templates")
    } else if (r.data.status_code === 400) {
      setFieldErrors(r.data.data)
    }
  }

  const handleSubmit = () => {
    if (uid) {
      sendAjax({
        url: `${BACKEND_URL}/api/v1/notifications/admin/templates/${uid}/`,
        method: 'put',
        data: formValues,
      }).then(
        afterSubmit
      )
    } else {
      sendAjax({
        url: `${BACKEND_URL}/api/v1/notifications/admin/templates/`,
        method: 'post',
        data: formValues,
      }).then(
        afterSubmit
      )
    }
  }

  const handleChange = (event) => {
    setFormValues({...formValues, [event.target.name]: getInputValue(event.target)})
    setFieldErrors({})
  }

  return (
    <AdminContainer>
      <Helmet>
        <title>Templates - {BRAND_NAME}</title>
      </Helmet>

      <Box
        component={ValidatorForm}
        ref={form}
        onSubmit={handleSubmit}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <TextValidator
              label={'Subject'}
              placeholder={'Subject'}
              name={'subject'}
              variant={'outlined'}
              fullWidth={true}
              validators={['required']}
              errorMessages={['This field is required']}
              onChange={handleChange}
              value={formValues.subject}
              {...getFieldErrorParams(fieldErrors, 'subject')}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <TextValidator
              select
              label="Template Type"
              name={'template_type'}
              variant={'outlined'}
              fullWidth={true}
              validators={['required']}
              errorMessages={['This field is required']}
              onChange={handleChange}
              value={formValues.template_type}
              {...getFieldErrorParams(fieldErrors, 'template_type')}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value={10}>Order Receipt Email</MenuItem>
              <MenuItem value={20}>New Order Telegram Message</MenuItem>
              <MenuItem value={30}>Reset Password Email</MenuItem>
            </TextValidator>
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <TextValidator
              select
              label="Status"
              name={'status'}
              variant={'outlined'}
              fullWidth={true}
              validators={['required']}
              errorMessages={['This field is required']}
              onChange={handleChange}
              value={formValues.status}
              {...getFieldErrorParams(fieldErrors, 'status')}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value={10}>Enabled</MenuItem>
              <MenuItem value={20}>Disabled</MenuItem>
            </TextValidator>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <TextValidator
              label={'Body'}
              name={'body'}
              placeholder={'HTML Template'}
              variant={'outlined'}
              fullWidth={true}
              multiline={true}
              rows={10}
              validators={['required']}
              errorMessages={['This field is required']}
              onChange={handleChange}
              value={formValues.body}
              {...getFieldErrorParams(fieldErrors, 'body')}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>

        <Button
          color={'primary'}
          type={'submit'}
          variant="contained"
          sx={{
            margin: '20px 0 20px 0',
          }}
          onClick={() => {
          }}
        >
          Save
        </Button>
      </Box>
    </AdminContainer>
  )
}

export default TemplateCreateUpdateAdminPage
